import React, { Component } from "react"
import ReactLoading from 'react-loading'
import Select from "../../../components/Select"
import helper from "../../../utils/helper"
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import { getClientesModulo, createOptionsClientes } from "../../../services/clientes" 
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import CsvDownloader from 'react-csv-downloader'
import Dashboard from "./Dashboard/index.js"
import pdfMake from 'pdfmake'
import GenericInputDate from "../../../components/GenericInputDate.js"

pdfMake.fonts = {
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    }
}

class RelatorioFaturamento extends Component {
    userInfo = auth.getUserInfo()
    
    state = {
        detalhes: { planos: [], clientes: [], faturamento_por: null, periodo_faturamento: null, tipo_plano: null },
        gerarRelatorio: false,
        relatorioGerado: false,
        tab: 0,
        allPlanos: [],
        optionsPlanos: [],
        optionsClientesPorPlano: {},
        optionsTipoPlano: [
            { label: "Assinatura", value: "assinatura" },
            { label: "Sob Demanda", value: "sob_demanda" }
        ],
        availableClientes: [],
        optionsFaturamento: [
            { label: "Hora", value: "hora" },
            { label: "Dia", value: "dia" },
            { label: "Mês", value: "mes" },
            { label: "Ano", value: "ano" }
        ],
        clientes: [],
        dataRelatorio: {},
        faturamento_por: null,
        csv: { data: [], columns: [] },
        info: {
            informacoes_faturamento: `Para que o valor de faturamento seja calculado corretamente, é necessário que as aplicações estejam vinculadas aos respectivos clientes. Sem esse vínculo, não é possível gerar o faturamento das aplicações, pois o relatório foi desenvolvido com foco no acompanhamento comercial da plataforma, considerando os valores relacionados aos clientes atendidos.<br /><br />
                                        Dessa forma, o relacionamento entre aplicação e cliente garante maior precisão nas informações apresentadas e permite uma análise mais confiável do faturamento.`,
            periodo: 'Selecionar período traz os dados do período selecionado, se vazio será exibido os dados de hoje.',
            planos: 'Selecionar planos traz os clientes vinculados a eles, se vazio gera dados de todos os planos.',
            clientes: 'Selecionar clientes traz o faturamento de cada cliente selecionado, se vazio gera dados de todos os clientes.',
            tipo_plano: 'Selecionar tipo do plano é obrigatório para gerar o relatório.',
            faturamento_por: 'Ao selecionar a opção “Faturamento por”, o sistema calcula uma média com base no período informado. Caso nenhum período seja selecionado, os dados de faturamento serão apresentados diariamente. Esse recurso tem como objetivo fornecer uma estimativa de faturamento, sendo aplicável apenas para planos sob demanda.',
            assinatura: 'Assinatura: A fatura é gerada a cada período definido, com limite máximo de mensagens, dados trafegados ou dispositivos. Quando o limite é atingido, o acesso do cliente é limitado.',
            sob_demanda: 'Sob Demanda: A fatura é gerada a cada quantidade de mensagens, dados trafegados ou dispositivos é atingida.'
        }
    }

    componentDidMount = async () => {
        await getClientesModulo('lns').then((clientes) => this.setState({ clientes: createOptionsClientes(clientes) }) )
        this.getPlanos()
    }

    getPlanos = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/planos/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        this.setState({ carregando_dados: true })
        axios.get(requestURL, config_me).then(({ data }) => {
            const clientes = this.state.clientes
            let allPlanos = []
            let optionsClientesPorPlano = {}

            data.results.forEach((item) => {
                let tipoPlanoValue = (item.tipo || "").toLowerCase().replace(/\s/g, "_")
                let plano = { label: item.nome, value: item.id, tipo: tipoPlanoValue }
                allPlanos.push(plano)
                optionsClientesPorPlano[item.id] = clientes.filter((cliente) => item.cliente.includes(cliente.value))
            })

            this.setState({ allPlanos, optionsPlanos: allPlanos, optionsClientesPorPlano })
            this.setState({ carregando_dados: false })
        })
    }

    handleChange = (field, value, isNumber = false) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        if(isNumber){
            value = helper.justNumbers(value)
        }

        detalhes[field] = value
        
        if(span) {
            span.innerHTML = ""
        }

        if(field === "tipo_plano") {
            const tipoSelecionado = value ? value.value : null
            let optionsPlanosFiltrados = []
            if (tipoSelecionado) {
                optionsPlanosFiltrados = this.state.allPlanos.filter(plano => plano.tipo === tipoSelecionado)
            } else {
                optionsPlanosFiltrados = this.state.allPlanos
            }

            detalhes.planos = []
            detalhes.clientes = []
            this.setState({ 
                optionsPlanos: optionsPlanosFiltrados,
                availableClientes: [],
                detalhes
            })
            return
        }

        if(field === "planos") {
            detalhes.clientes = []
            this.updateAvailableClientes(value)
        }

        if(detalhes.tipo_plano != null && detalhes.faturamento_por != null) {
            this.setState({gerarRelatorio: true})
        } else {
            this.setState({gerarRelatorio: false})
        }

        this.setState({ detalhes })
    }

    updateAvailableClientes = (planosSelecionados) => {
        const { optionsClientesPorPlano } = this.state
        let clientesDisponiveis = []
        
        planosSelecionados.forEach(plano => {
            const clientesDoPlano = optionsClientesPorPlano[plano.value] || []
            clientesDisponiveis = [...clientesDisponiveis, ...clientesDoPlano]
        })

        const clientesUnicos = clientesDisponiveis.filter((cliente, index, self) => 
            index === self.findIndex(c => c.value === cliente.value)
        )

        this.setState({ 
            availableClientes: clientesUnicos
        })
    }

    gerarRelatorio = () => {
        this.setState({ carregando_dados: true, relatorioGerado: false })

        const detalhes = this.state.detalhes
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/relatorio/faturamento/'

        let planos_clientes = []

        detalhes.planos.forEach(plano => {
            const clientesDoPlano = detalhes.clientes.filter(cliente => {
                const clientesDisponiveis = this.state.optionsClientesPorPlano[plano.value] || []
                return clientesDisponiveis.some(c => c.value === cliente.value)
            })

            if (clientesDoPlano.length > 0) {
                planos_clientes.push({
                    plano_id: plano.value,
                    clientes_ids: clientesDoPlano.map(c => c.value)
                })
            }
        })

        const data  = {
            faturamento_por: detalhes?.faturamento_por?.value || null,
            periodo_faturamento: detalhes?.periodo_faturamento ? {
                data_inicial: detalhes.periodo_faturamento.startDate, 
                data_final: detalhes.periodo_faturamento.endDate + 1
            } : null,
            planos_clientes: planos_clientes.length > 0 ? planos_clientes : null,
            tipo_plano: detalhes?.tipo_plano?.value
        }

        axios({
            method: "POST",
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(({ data }) => {
            this.formatarCsv(data)

            this.setState({ carregando_dados: false, relatorioGerado: true, dataRelatorio: data, faturamento_por: detalhes.faturamento_por })
        })
        .catch((error) => {
            this.setState({ carregando_dados: false, relatorioGerado: false, dataRelatorio: {}, faturamento_por: null })
        })
    }

    formatarCsv = (data) => {
        const { detalhes } = this.state
        const csv = { data: [], columns: [] }
        
        const isSobDemanda = data.relatorio_de_cada_plano[0]?.tipo_plano === 'sob_demanda'
        
        if (isSobDemanda) {
            csv.columns = [
                { id: 'c0', displayName: 'Plano' },
                { id: 'c1', displayName: 'Valor Mensagem' },
                { id: 'c2', displayName: 'Valor Dispositivo' },
                { id: 'c3', displayName: 'Valor Dados Trafegados' },
                { id: 'c4', displayName: 'Tipo Plano' },
                { id: 'c5', displayName: 'Qtd.Clientes' },
                { id: 'c6', displayName: 'Faturamento' },
                { id: 'c7', displayName: `Faturamento por ${detalhes.faturamento_por.label}` },
                { id: 'c8', displayName: 'Média por Cliente' },
                { id: 'c9', displayName: 'Faturamento Mensagens' },
                { id: 'c10', displayName: 'Faturamento Dispositivos' },
                { id: 'c11', displayName: 'Faturamento Dados' },
            ]
        } else {
            csv.columns = [
                { id: 'c0', displayName: 'Plano' },
                { id: 'c1', displayName: 'Valor' },
                { id: 'c2', displayName: 'Cobrança' },
                { id: 'c3', displayName: 'Qtd.Clientes' },
                { id: 'c4', displayName: 'Faturamento' },
                { id: 'c5', displayName: `Faturamento por ${detalhes.faturamento_por.label}` },
                { id: 'c6', displayName: 'Média por Cliente' },
            ]
        }

        const limitarTexto = (texto) => {
            if (typeof texto !== 'string') 
                texto = texto ? texto.toString() : ''
            let resultado = ''
            let i = 0
            while (i < texto.length) {
                resultado += texto.substring(i, i + 10)
                if (i + 10 < texto.length) 
                    resultado += '\n'
                i += 10
            }
            return resultado
        }

        data.relatorio_de_cada_plano.forEach((item) => {
            if (isSobDemanda) {
                const row = {
                    c0: limitarTexto(item.plano),
                    c1: limitarTexto(helper.formatMoney(item.valor_mensagem)),
                    c2: limitarTexto(helper.formatMoney(item.valor_dispositivo)),
                    c3: limitarTexto(helper.formatMoney(item.valor_dados_trafegados)),
                    c4: 'Sob Demanda',
                    c5: limitarTexto(item.quantidade_de_clientes_selecionados),
                    c6: limitarTexto(helper.formatMoney(item.total_de_faturamento)),
                    c7: limitarTexto(helper.formatMoney(item[`total_de_faturamento_por_${detalhes.faturamento_por.value}`])),
                    c8: limitarTexto(helper.formatMoney(item.media_de_faturamento_por_cliente)),
                    c9: limitarTexto(helper.formatMoney(item.total_de_faturamento_mensagens)),
                    c10: limitarTexto(helper.formatMoney(item.total_de_faturamento_dispositivos)),
                    c11: limitarTexto(helper.formatMoney(item.total_de_faturamento_dados_trafegados))
                }
                csv.data.push(row)
            } else {
                const row = {
                    c0: limitarTexto(item.plano),
                    c1: limitarTexto(helper.formatMoney(item.valor)),
                    c2: limitarTexto(item.cobranca),
                    c3: limitarTexto(item.quantidade_de_clientes_selecionados),
                    c4: limitarTexto(helper.formatMoney(item.total_de_faturamento)),
                    c5: limitarTexto(helper.formatMoney(item[`total_de_faturamento_por_${detalhes.faturamento_por.value}`])),
                    c6: ''
                }
                csv.data.push(row)
            }
        })

        if (isSobDemanda) {
            csv.data.push(
                {
                    c0: 'Totais',
                    c1: '',
                    c2: '',
                    c3: '',
                    c4: '',
                    c5: limitarTexto(data.quantidade_de_clientes_selecionados),
                    c6: limitarTexto(helper.formatMoney(data.total_de_faturamento)),
                    c7: limitarTexto(helper.formatMoney(data[`total_de_faturamento_por_${detalhes.faturamento_por.value}`])),
                    c8: '',
                    c9: limitarTexto(helper.formatMoney(data.total_de_faturamento_mensagens)),
                    c10: limitarTexto(helper.formatMoney(data.total_de_faturamento_dispositivos)),
                    c11: limitarTexto(helper.formatMoney(data.total_de_faturamento_dados_trafegados))
                }
            )
        } else {
            csv.data.push(
                {
                    c0: 'Totais',
                    c1: '',
                    c2: '', 
                    c3: limitarTexto(data.quantidade_de_clientes_selecionados),
                    c4: limitarTexto(helper.formatMoney(data.total_de_faturamento)),
                    c5: limitarTexto(helper.formatMoney(data[`total_de_faturamento_por_${detalhes.faturamento_por.value}`])),
                    c6: limitarTexto(helper.formatMoney(data.media_de_faturamento_por_cliente))
                }
            )
        }

        this.setState({ csv })
    }

    exportarPDF = () => {
        const { csv } = this.state

        const columns = csv.columns.map(item => item.displayName)

        let table = []
        let widths = []

        const header_style = {
            fillColor: '#e0e0e0',
            color: '#444',
            bold: true,
            fontSize: 8
        }

        const headerRow = columns.map(col => ({
            text: col,
            ...header_style
        }))
        table.push(headerRow)

        columns.forEach(() => {
            widths.push("*")
        })

        csv.data.forEach((item) => {
            let row = []
            
            csv.columns.forEach((col, index) => {
                const key = `c${index}`
                let value = item[key] || ''

                if(item._headerStyle) {
                    row.push({text: value, ...header_style})
                    return
                }

                if (item[key] === 'Totais') {
                    row.push({text: value, ...header_style})
                    return
                }

                row.push({text: value, fontSize: 8})
            })
            
            table.push(row)
        })

        const pdfOptions = {
            pageOrientation: 'landscape',
            content: [
                {
                    table: {
                        widths: ['*', 80],
                        body: [
                            [
                                {
                                    text: ['\n', '\n', this.userInfo.email],
                                    border: [false, false, false, true]
                                },
                                { image: 'logo', style: 'logo', width: 80, border: [false, false, false, true] }
                            ]
                        ],
                    },
                },
                '\n\n\n',
                {
                    text: 'Relatório de Faturamento',
                    style: 'header',
                    alignment: 'center'
                },
                '\n',
                {
                    table: {
                        widths: widths,
                        body: table,
                        headerRows: 1
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex === 0 ? '#e0e0e0' : null;
                        }
                    }
                }
            ],
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                }
            },
            images: { 'logo': document.querySelector('div.hdv-logomarca img')?.src, },
        }

        const win = window.open('', '_blank')
        pdfMake.createPdf(pdfOptions).open({}, win)
    }
    handleTab = (index) => this.setState({ tab: index })

    showInfo = (info) => {
        helper.dispatchEvent("showAviso", {
            message: info
        })
    }

    render() {
        const { 
            detalhes, 
            gerarRelatorio, 
            relatorioGerado, 
            carregando_dados, 
            dataRelatorio,
            faturamento_por,
            info,
            optionsPlanos,
            optionsTipoPlano,
            tab
        } = this.state

        return (
            <div className="hdv-render-div">
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <i
                            className="fa fa-info-circle fa-20px"
                            title='Informações do Relatório de Faturamento'
                            style={{ cursor: "pointer", marginTop: '8px', marginRight: '5px' }}
                            onClick={() =>
                                helper.dispatchEvent("showAviso", {
                                    message: informacoes_faturamento,
                                })
                            }
                        />
                        <h4>Relatório de Faturamento</h4>
                        <div className="gray-background">
                            <i className="las la-hand-holding-usd la-2x"></i>
                        </div>
                    </span>
                    <ReactLoading className={(carregando_dados) ? "hdv-report-loading" : "hdv-noshow-item"} type="cylon" color="var(--background-menu)" width={50} />
                </div>

                <Tabs className="tabs-style" selectedIndex={tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab>Relatório</Tab>
                        <Tab disabled={!relatorioGerado}>Dashboard</Tab>
                    </TabList>
                    <TabPanel>
                        <details open className='custom-summary'>
                            <summary>Filtros</summary>

                            <div className="hdv-form-default" style={{padding: "0 20px 20px"}}>
                                <div className="row align-items-end">
                                    <div className="col-md-4">
                                        <label>
                                            Periodo
                                            &nbsp;
                                            <i className="las la-info-circle" style={{cursor: "pointer"}} onClick={() => this.showInfo(info.periodo)} title={info.periodo}></i>
                                        </label>
                                        <GenericInputDate
                                            onChange={(objectDate) => this.handleChange("periodo_faturamento", objectDate)}
                                            haveInitialValue
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="required">
                                            Tipo do Plano
                                            &nbsp;
                                            <i className="las la-info-circle" style={{ cursor: "pointer" }} onClick={() => this.showInfo(!detalhes.tipo_plano ? info.tipo_plano : info[detalhes.tipo_plano?.value])} title={!detalhes.tipo_plano ? info.tipo_plano : info[detalhes.tipo_plano?.value]}></i>
                                        </label>
                                        <Select
                                            options={optionsTipoPlano}
                                            value={detalhes.tipo_plano}
                                            onChange={(e) => this.handleChange("tipo_plano", e)}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="required">
                                            Faturamento por
                                            &nbsp;
                                            <i className="las la-info-circle" style={{cursor: "pointer"}} onClick={() => this.showInfo(info.faturamento_por)} title={info.faturamento_por}></i>
                                        </label>
                                        <Select
                                            onChange={(e) => this.handleChange("faturamento_por", e)}
                                            options={this.state.optionsFaturamento}
                                            value={detalhes.faturamento_por}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>
                                            Planos
                                            &nbsp;
                                            <i className="las la-info-circle" style={{cursor: "pointer"}} onClick={() => this.showInfo(info.planos)} title={info.planos}></i>
                                        </label>
                                        <Select
                                            forceHeightAuto
                                            isMulti
                                            value={detalhes.planos}
                                            options={optionsPlanos}
                                            onChange={(e) => this.handleChange("planos", e)}
                                            disabled={!detalhes.tipo_plano}
                                            placeholder="Todos"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label>
                                            Clientes
                                            &nbsp;
                                            <i className="las la-info-circle" style={{cursor: "pointer"}} onClick={() => this.showInfo(info.clientes)} title={info.clientes}></i>
                                        </label>
                                        <Select
                                            forceHeightAuto
                                            isMulti
                                            value={detalhes.clientes}
                                            options={this.state.availableClientes || []}
                                            disabled={detalhes.planos.length === 0}
                                            onChange={(e) => this.handleChange("clientes", e)}
                                            placeholder="Todos"
                                        />
                                    </div>
                                </div>
                            </div>
                        </details>

                        <div className="hdv-btn-group">
                            <button disabled={!this.state.detalhes.tipo_plano || !this.state.detalhes.faturamento_por} onClick={this.gerarRelatorio} className="hdv-btn-forms hdv-btn-blue">Gerar Relatório</button>

                            <CsvDownloader
                                style={{ border: 'none' }}
                                columns={this.state.csv.columns}
                                datas={this.state.csv.data}
                                filename={`relatorio_lns_faturamento.csv`}
                                separator=";"
                            >
                                <button disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-green">Exportar CSV</button>
                            </CsvDownloader>

                            <button onClick={this.exportarPDF} disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-red">Exportar PDF</button>
                        </div>

                        {relatorioGerado ?
                            <div style={{overflow: "auto"}}>
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            <th>Plano</th>
                                            <th>Tipo Plano</th>
                                            {dataRelatorio.relatorio_de_cada_plano[0]?.tipo_plano === 'sob_demanda' ? (
                                                <>
                                                    <th>Valor Mensagem</th>
                                                    <th>Valor Dispositivo</th>
                                                    <th>Valor Dados Trafegados</th>
                                                </>
                                            ) : (
                                                <th>Valor</th>
                                            )}
                                            <th>Qtd.Clientes</th>
                                            <th>Faturamento</th>
                                            <th>Faturamento por {faturamento_por.label}</th>
                                            <th>Média por Cliente</th>
                                            {dataRelatorio.relatorio_de_cada_plano[0]?.tipo_plano === 'sob_demanda' && (
                                                <>
                                                    <th>Faturamento Mensagens</th>
                                                    <th>Faturamento Dispositivos</th>
                                                    <th>Faturamento Dados</th>
                                                </>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataRelatorio.relatorio_de_cada_plano.map((plano, index) => {
                                                return(
                                                    <tr key={index}>
                                                        <td>{plano.plano}</td>
                                                        <td>{plano.tipo_plano === 'sob_demanda' ? 'Sob Demanda' : 'Assinatura'}</td>
                                                        {plano.tipo_plano === 'sob_demanda' ? (
                                                            <>
                                                                <td>{helper.formatMoney(plano.valor_mensagem)}</td>
                                                                <td>{helper.formatMoney(plano.valor_dispositivo)}</td>
                                                                <td>{helper.formatMoney(plano.valor_dados_trafegados)}</td>
                                                            </>
                                                        ) : (
                                                            <td>{helper.formatMoney(plano.valor)}</td>
                                                        )}
                                                        <td>{plano.quantidade_de_clientes_selecionados}</td>
                                                        <td>{helper.formatMoney(plano.total_de_faturamento)}</td>
                                                        <td>{helper.formatMoney(plano[`total_de_faturamento_por_${faturamento_por.value}`])}</td>
                                                        <td>{helper.formatMoney(plano.media_de_faturamento_por_cliente)}</td>
                                                        
                                                        {plano.tipo_plano === 'sob_demanda' && (
                                                            <>
                                                                <td>{helper.formatMoney(plano.total_de_faturamento_mensagens)}</td>
                                                                <td>{helper.formatMoney(plano.total_de_faturamento_dispositivos)}</td>
                                                                <td>{helper.formatMoney(plano.total_de_faturamento_dados_trafegados)}</td>
                                                            </>
                                                        )}
                                                    </tr>
                                                )
                                            })
                                        }

                                        <tr>
                                            <td colSpan={dataRelatorio.relatorio_de_cada_plano[0]?.tipo_plano === 'sob_demanda' ? 5 : 3}>Totais</td>
                                            <td>{dataRelatorio.quantidade_de_clientes_selecionados}</td>
                                            <td>{helper.formatMoney(dataRelatorio.total_de_faturamento)}</td>
                                            <td>{helper.formatMoney(dataRelatorio[`total_de_faturamento_por_${faturamento_por.value}`])}</td>
                                            <td></td>
                                            {dataRelatorio.relatorio_de_cada_plano[0]?.tipo_plano === 'sob_demanda' && (
                                                <>
                                                    <td>{helper.formatMoney(dataRelatorio.total_de_faturamento_mensagens)}</td>
                                                    <td>{helper.formatMoney(dataRelatorio.total_de_faturamento_dispositivos)}</td>
                                                    <td>{helper.formatMoney(dataRelatorio.total_de_faturamento_dados_trafegados)}</td>
                                                </>
                                            )}
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        : null}
                    </TabPanel>
                    <TabPanel>
                        <Dashboard data={dataRelatorio} faturamento_por={faturamento_por}/>
                    </TabPanel>
                </Tabs>
                   
            </div>
        )
    }
}

export default RelatorioFaturamento